/* eslint-disable */

import { color } from 'echarts';
import React from 'react';

const R2RMiniStat = ({
  title = '',
  value = '',
  changeText = '',
  isIncrease = null, // Using null for "No Change"
  showArrow = true,
  icon, // Accepts a React Node for the icon (e.g., Emoji, SVG, or Component)
}) => {

  // --- Style Logic ---

  let trendColor = '#6c757d'; // Grey for No Change
  if (isIncrease === true) {
    trendColor = '#198754'; // Green for Increase (Success Green)
  } else if (isIncrease === false) {
    trendColor = '#dc3545'; // Red for Decrease (Danger Red)
  }

  // Unicode character for the arrow
  const arrowIcon = isIncrease === true ? '↗' : (isIncrease === false ? '↘' : '');
  
  // --- Inline Styles ---
  
  const styles = {
    card: {
      display: 'flex',
      // We keep alignItems: 'flex-start' for the outer container so text/icon aligns at the top
      alignItems: 'flex-start', 
      padding: '16px',
      border: '1px solid #e0e0e0',
      borderRadius: '8px',
      backgroundColor: '#ffffff',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.20)', 
      fontFamily: 'Inter, sans-serif',
      width: '100%',
      minHeight: '130px', 
      position: 'relative', // Set context for absolute positioning of the trend
    },
    iconCircle: {
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      backgroundColor: 'white', 
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginRight: '16px',
      // border: '1px solid #2196f3',
      // border: '2px solid #e3f2fd',
      flexShrink: 0,
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.10)'
    },
    icon: {
      fontSize: '18px',
      color: '#2196f3',
      // color: '#e3f2fd'
    },
    // Style for a React Node icon (like an Emoji or SVG)
    iconText: {
      fontSize: '18px',
      color: '#2196f3',
    },
    iconImage: {
        width: '24px', // Adjust size for PNG/image inside the 40px circle
        height: '24px',
        objectFit: 'contain',
    },
    content: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      // The content block now starts at the top of the card
      paddingTop: '0', 
    },
    title: {
      fontSize: '11px',
      color: '#656c72ff',
      fontWeight: '500',
      marginBottom: '4px',
      lineHeight: '1.2',
    },
    value: {
      fontSize: '20px', // Made larger for visual weight
      fontWeight: '700',
      color: '#343a40',
      lineHeight: '1',
      // Added margin to separate title/value block from the icon
      marginTop: '22px', 
    },
    highlight: {
      backgroundColor: '#e6e6fa',
      padding: '1px 4px',
      borderRadius: '4px',
      fontWeight: 'bold',
      color: '#333',
    },
    // The trend is now positioned relative to the card, pushing it to the bottom right
    trend: {
      position: 'absolute', 
      bottom: '16px', // Align with card padding bottom
      right: '16px', // Align with card padding right
      display: 'flex',
      alignItems: 'center',
      fontSize: '12px',
      fontWeight: '600',
      whiteSpace: 'nowrap', 
      color: trendColor, 
    },
  };

  // --- Component Render ---

  // Determine the content to render inside the icon circle
  const iconContent = typeof icon === 'string' ? (
    <img 
      src={icon} 
      alt="Statistic Icon" 
      style={styles.iconImage} 
      // Fallback for image loading failure
      onError={(e) => {
        e.target.style.display = 'none'; // Hide broken image
      }}
    />
  ) : (
    <span style={styles.iconText}>
      {icon || '📊'} 
    </span>
  );

  return (
    <div style={styles.card}>
      
      {/* 1. Icon Container (Aligned to the top edge of the card due to outer flex-start) */}
      {/* <div style={styles.iconCircle}>
        <span style={styles.icon}>
          {icon || '📊'} 
        </span>
      </div> */}
      <div style={styles.iconCircle}>
        {iconContent}
      </div>

      {/* 2. Main Content Block (Title and Value) */}
      <div style={styles.content}>
        
        {/* Title */}
        <div style={styles.title}>
          {title.split(' ').map((word, index, arr) => (
            <React.Fragment key={index}>
              {word}
              {word === 'ITEMS' && (
                <span style={styles.highlight}> ITEMS</span>
              )}
              {word !== 'ITEMS' && index < arr.length - 1 && ' '}
            </React.Fragment>
          ))}
        </div>
        
        {/* Value (This naturally falls beneath the title) */}
        <div style={styles.value}>{value || '0'}</div>
      </div>

      {/* 3. Trend Indicator (Absolutely positioned to the bottom right) */}
      <div style={styles.trend}>
        {showArrow && arrowIcon && (
          <span role="img" aria-label="Trend Arrow" style={{ marginRight: '4px', fontSize: '10px' }}>
            {arrowIcon}
          </span>
        )}
        {changeText}
      </div>
      
    </div>
  );
};

export default R2RMiniStat;